import React, { useLayoutEffect, useMemo, useCallback } from 'react';
import { Select } from '@sas/nova-commons/components/Select';
import { useDesignTokens } from '@sas/nova-commons/theme';
import { setConstraints } from '../../store/birdLayout/BirdLayoutState';
import { ComboBoxState } from '../../store/birdElement/comboBoxState';
import { useI18n } from '../../locale/I18nContext';
import { connect } from 'react-redux';
import { selectBirdComboBoxState, selectStyleState, selectAccessibilityLabelState, } from '../../store/selectors';
import { bindActionCreators } from 'redux';
import { fontStyles, textHeight, longestTextWidthForValues, listStyleTokenOverrides, } from '../utils/style';
import { useFontLoadedKey } from '../FontProvider';
import { exposeTestId } from '../../config';
const dropdownWidthPadding = 16 + 2 /* outer box padding + border*/ + 18; /* arrow width + margin */
export const BirdComboBoxBase = function (props) {
    const defaultText = useI18n({ key: 'ComboBox.clearFilter.txt' });
    const { values, measureValues, label, required } = props.state;
    const actions = props.actions;
    const { font } = props.style || {};
    const listTokenOverridesCb = useCallback((cbProps) => {
        return listStyleTokenOverrides(cbProps, props.style);
    }, [props.style]);
    const selectBoxOverrides = useCallback(() => {
        if (!props.style) {
            return;
        }
        return props.style.normal;
    }, [props.style]);
    const tokenOverrides = useCallback(() => (props.style ? props.style.normal : undefined), [
        props.style,
    ]);
    const combinedValues = useMemo(() => {
        if (!values) {
            return;
        }
        return values.map((value, index) => {
            return {
                text: value,
                secondaryText: measureValues ? measureValues[index] : undefined,
                concatSecondaryText: true,
            };
        });
    }, [values, measureValues]);
    {
        const dt = useDesignTokens();
        const fonts = useMemo(() => fontStyles(font, dt), [font, dt]);
        const fontKey = useFontLoadedKey(fonts.fontFamily);
        const preferredValues = props.preferredSizing ? combinedValues : undefined;
        useLayoutEffect(() => {
            const selectHeight = Math.max(28 /* min height 1.75rem */, textHeight(fonts) + 2 /* 2px for border */ + 8 /* 8px for padding */);
            const constraints = {
                preferredHeight: selectHeight,
                minHeight: selectHeight,
                minWidth: 160,
            };
            if (props.preferredSizing) {
                constraints.preferredWidth =
                    longestTextWidthForValues(preferredValues, fonts) + dropdownWidthPadding;
            }
            actions.setConstraints(props.id, constraints);
        }, [fontKey /*(implicit)*/, preferredValues, actions, props.id, props.preferredSizing, fonts]);
    }
    return (React.createElement(Select, { style: {
            maxWidth: 'none',
        }, popoverTokens: { theme: tokenOverrides }, listTokens: { font, theme: listTokenOverridesCb }, selectTokens: { font, theme: selectBoxOverrides }, testId: exposeTestId() ? `${props.id}-dropdown` : null, unselectedValue: required ? undefined : { item: { text: defaultText }, placeholder: label }, values: combinedValues, selectedIndex: props.state.selectedIndex, onSelected: (selectedIndex) => actions.update(props.id, {
            selectedIndex: selectedIndex,
        }), ariaLabel: props.accessibilityLabel, displaySecondaryText: true }));
};
export const BirdComboBox = connect((state, props) => ({
    state: selectBirdComboBoxState(state, props.id),
    style: selectStyleState(state, props.id),
    accessibilityLabel: selectAccessibilityLabelState(state, props.id),
}), (dispatch) => ({
    actions: bindActionCreators(Object.assign({ setConstraints }, ComboBoxState.actions), dispatch),
}))(BirdComboBoxBase);
